export default __webpack_public_path__ + "static/media/registration_background.c7eb44e4.jpg";